/* unplugin-vue-components disabled */import { render } from "./NavAside.vue?vue&type=template&id=088f122a&scoped=true"
import script from "./NavAside.vue?vue&type=script&lang=js"
export * from "./NavAside.vue?vue&type=script&lang=js"

import "./NavAside.vue?vue&type=style&index=0&id=088f122a&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088f122a"]])

export default __exports__